const form = {
  formId: "new-user-form",
  formField: {},
};

export default form;
